export default defineComponent({
	props: {
		tag: {type: String, required: false, default: 'div', validate: (val: string) => ['div', 'ul'].includes(val)},
		separator: { type: [Boolean,String], required: false, default: false },
		accordion: { required: false, default: false}
	},
	components: {
		GsSeparator: 'GsSeparator'
	},
	setup(props: any, ctx: any) {
		const accordion = props.accordion === '' ? ref<string>(undefined) : props.accordion
		provide('accordion', accordion)
		const attrs: any = {}
		if (props.tag === 'ul') {
			attrs.class = 'list-none'
			if (props.separator) {
				attrs.class += ' divide-y'
				if (props.separator !== true)
					attrs.class += ' '+props.separator
			}
		}
		const items = computed(() => props.tag === 'ul'
			? ctx.slots.default().map((e: any, idx: number) => h('li', e))
			: props.separator
				? ctx.slots.default().map((e: any, idx: number) =>
					idx < ctx.slots.default().length
						? [e, h('GsSeparator', props.separator && props.separator !== true ? {class: props.separator} : undefined)]
						: e
				  )
				: ctx.slots.default()
		);
		return {
			attrs,
			items,
			tag: props.tag
		}
	},
	render () {
		return h(this.tag, this.attrs, this.items)
	}
})
